import { InjectionToken } from '@angular/core';
import { GgEnvironment } from '@core/models/environment.interfaces';

export const ENVIRONMENT: InjectionToken<GgEnvironment> = new InjectionToken('ENVIRONMENT');
